/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  createAlert (param) {
    return Api().get(`/api/v1.0/custom-alert/${param.plantId}/${param.timestamp}/${param.deviceType}/${param.blockId}/${param.roomId}/${param.deviceId}/${param.inverterId}/${param.scbId}/${param.wsId}/${param.alertStatus}/${param.alertReason}/${param.alertCode}/${param.message}/${param.updatedBy}`)
  }
}
